import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'smart-fix-instruction-display-component',
  templateUrl: './instruction-display-component.component.html',
  styleUrls: ['./instruction-display-component.component.scss'],
})
export class InstructionDisplayComponentComponent implements OnInit {
  sanitizedDescription!: SafeHtml;

  @Input() icon?: string;
  @Input() description?: string;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.sanitizedDescription = this.sanitizer.bypassSecurityTrustHtml(
      this.description || ''
    );
  }
}
